import React from "react";
import SignInLayer from "../../components/General/SignInLayer";

const SignInPage = () => {
  return (
    <>

      {/* SignInLayer */}
      <SignInLayer />

    </>
  );
};

export default SignInPage; 
